// The backend prices an omitted shipping_type as default_shipping_type, so the
// first quote already reflects the default method. The selection stays unset
// until the user picks a method, which keeps the default out of the quote key
// and avoids a second, identical quote. UI and order placement fall back to the
// quote's default instead.
export const selectedShippingType = (shippingType, priceData) =>
  shippingType ?? priceData?.default_shipping_type;

// Names from Order::SHIPPING_TYPE in photolane-backend (models/order.rb).
const SHIPPING_TIERS = ['standard', 'express', 'economy', 'international_economy', 'international'];

export const shippingTier = type => SHIPPING_TIERS[type] ?? `${type}`;
